module.exports = "/assets/data/70bd4755b04e554408b2d33407f5f00b-KT9.data.json";